<template>
  <div class="content-center">
    <div class="banner">
      <div class="content">
        <div class="banner-title">云采购解决方案</div>
        <div class="line" />
        <div class="desc">
          打通从工厂端到零售端的直通链路的采购服务体系，撮合上下游供应采购
          一体化，让企业销售业务在线化、数字化，提升效率，降低成本
        </div>
        <div class="btn-wrap">
          <div
            class="btn"
            @click="openModal"
          >免费试用</div>
        </div>
      </div>
    </div>
    <div class="abuse">
      <div class="sk-block-title">
        <div class="title">传统企业销售渠道的弊端</div>
      </div>
      <div class="cont">
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/cloudPurchase/cloudPurchase_abuse1.png" alt="">
          </div>
          <p>新型渠道拓展难</p>
        </div>
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/cloudPurchase/cloudPurchase_abuse2.png" alt="">
          </div>
          <p>整体盈利能力下降</p>
        </div>
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/cloudPurchase/cloudPurchase_abuse3.png" alt="">
          </div>
          <p>政策无法有效传递</p>
        </div>
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/cloudPurchase/cloudPurchase_abuse4.png" alt="">
          </div>
          <p>上下游信息不对称</p>
        </div>
      </div>
    </div>
    <div class="sale">
      <div class="sk-block-title">
        <div class="title">云采购平台,帮助企业实现销售全流程协同</div>
        <div class="sub-title">覆盖全行业，为各行业提供垂直解决方案，充分满足个性化需求</div>
      </div>
      <div class="cont">
        <div class="saleCard">
          <img src="@/assets/images/cloudPurchase/cloudPurchase_sale1.png" alt="">
          <div class="cardTitle">销售商城</div>
          <div class="cardSubTitle">全天全时 订货在线</div>
          <p class="desc">提供pc、app、小程序等多端的数字化采购商城，实现业务从线下走向线上，节约采购成本</p>
        </div>
        <div class="saleCard">
          <img src="@/assets/images/cloudPurchase/cloudPurchase_sale2.png" alt="">
          <div class="cardTitle">销售管家</div>
          <div class="cardSubTitle">贴身客户 身边服务</div>
          <p class="desc">合同在线、代客下单、采购议价，自动拆单、返利政策等覆盖从售前到售后的实用功能，让采购交易更简单</p>
        </div>
        <div class="saleCard">
          <img src="@/assets/images/cloudPurchase/cloudPurchase_sale3.png" alt="">
          <div class="cardTitle">销售参谋</div>
          <div class="cardSubTitle">数据驱动 销售决策</div>
          <p class="desc">覆盖经营过程中的多角度数据分析，让数据去驱动业务的开展，支撑精准营销及数据化运营</p>
        </div>
        <div class="saleCard">
          <img src="@/assets/images/cloudPurchase/cloudPurchase_sale4.png" alt="">
          <div class="cardTitle">销售链接</div>
          <div class="cardSubTitle">渠道无界 业务连接</div>
          <p class="desc">通过云采购商城，可以和线下更多的供应链厂家合作，满足采购商多种商品诉求</p>
        </div>
      </div>
    </div>
    <div class="monitor">
      <div class="sk-block-title">
        <div class="title">让传统业务融入互联网，实现B2b业务全流程监控</div>
        <div class="sub-title">助力供应商、品牌商打造云采购商城，整合行业上下游资源，有效管理经销商及终端消费者</div>
      </div>
      <div class="imgWrap">
        <img src="@/assets/images/cloudPurchase/cloudPurchase_monitor.png" alt="">
      </div>
    </div>
    <div class="threeBlock">
      <div class="imgWrap">
        <img src="@/assets/images/cloudPurchase/cloudPurchase_buy.png" alt="">
      </div>
      <div class="paragraph">
        <div class="title">随时随地下单，流程全在线</div>
        <div class="colorBlock" />
        <div class="cont">
          客户在采购商城随时随地自主下单采购，商品流、订单流、物流、资金流全在线，还能够根据行业，智能
          运营推荐优质商品，销售成本减少，销售更高效
        </div>
      </div>
      <div class="paragraph">
        <div class="title">不同等级不同价格，不同区域不同价格</div>
        <div class="colorBlock" />
        <div class="cont">
          支持等级价、区域价、阶梯价等不同定价策略, 还可以设置相应的购买权限、起订量，限定量，多维护支持采购业务
          运营推荐优质商品，销售成本减少，销售更高效
        </div>
      </div>
      <div class="imgWrap">
        <img src="@/assets/images/cloudPurchase/cloudPurchase_price.png" alt="">
      </div>
      <div class="imgWrap">
        <img src="@/assets/images/cloudPurchase/cloudPurchase_recommend.png" alt="">
      </div>
      <div class="paragraph">
        <div class="title">智能推荐服务，促进交易高效转化</div>
        <div class="colorBlock" />
        <div class="cont">
          借力数据模型服务，会根据采购方多维度情况, 为其推荐潜在兴趣商品，推荐优质货源供应商，促进商品成交
        </div>
      </div>
    </div>
    <div class="pattern">
      <div class="sk-block-title">
        <div class="title">建立全渠道销售的移动电商新模式</div>
      </div>
      <div class="imgWrap">
        <img src="@/assets/images/cloudPurchase/cloudPurchase_pattern.png" alt="">
      </div>
    </div>
    <div class="industrySolutions">
      <div class="title">行业解决方案</div>
      <div class="solutions">
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/cloudPurchase/cloudPurchase_industrySolution1.png" alt="">
          </div>
          <p>家用电器</p>
        </div>
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/cloudPurchase/cloudPurchase_industrySolution2.png" alt="">
          </div>
          <p>农资行业</p>
        </div>
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/cloudPurchase/cloudPurchase_industrySolution3.png" alt="">
          </div>
          <p>交通出行</p>
        </div>
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/cloudPurchase/cloudPurchase_industrySolution4.png" alt="">
          </div>
          <p>酒水饮料</p>
        </div>
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/cloudPurchase/cloudPurchase_industrySolution5.png" alt="">
          </div>
          <p>家居建材</p>
        </div>
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/cloudPurchase/cloudPurchase_industrySolution6.png" alt="">
          </div>
          <p>数码3C</p>
        </div>
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/cloudPurchase/cloudPurchase_industrySolution7.png" alt="">
          </div>
          <p>餐饮行业</p>
        </div>
        <div class="item">
          <div class="imgWrap">
            <img src="@/assets/images/cloudPurchase/cloudPurchase_industrySolution8.png" alt="">
          </div>
          <p>快消行业</p>
        </div>
      </div>
    </div>
    <CarouselItem title="云采购" />
    <ConsultForm info-sources="云采购" />
    <TryModal v-if="visible" :visible="visible" info-sources="云采购" @cancel="modalClose" />
  </div>
</template>
<script>
import metaInfo from '@/common/util/metaInfo'
import ConsultForm from '@/components/ConsultForm'
import TryModal from '@/components/TryModal'
import CarouselItem from '@/components/CarouselItem'

export default {
  metaInfo: metaInfo.CloudPurchase,
  components: {
    ConsultForm,
    TryModal,
    CarouselItem
  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {

  },
  methods: {
    openModal: function() {
      this.visible = true
    },
    modalClose: function(data) {
      this.visible = data
    }
  }
}
</script>

<style lang="less" scoped>
.content-center {
  .banner {
    background: url("~@/assets/images/cloudPurchase/cloudPurchase_banner.png") no-repeat center;
    background-size: 100% 100%;
    min-width: 1200px;
    .content {
      width: 1200px;
      margin: 0 auto;
      padding: 53px 0;
      text-align: left;
      .banner-title {
        font-size: 48px;
        color: #FFFFFF;
        line-height: 55px;
      }
      .line {
        width: 100px;
        height: 6px;
        background: #28DAFB;
        margin: 16px 0 31px;
      }
      .desc {
        width: 640px;
        height: 101px;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 28px;
      }
      .btn-wrap {
        .btn {
          width: 200px;
          height: 58px;
          line-height: 58px;
          border-radius: 6px;
          border: 1px solid #FFFFFF;
          font-size: 22px;
          color: #FFFFFF;
          cursor: pointer;
          text-align: center;
          margin-top: 47px;
        }
      }
    }
  }
  .title {
    font-size: 36px;
  }
  .abuse {
    height: 500px;
    background: #fafafa;
    padding-bottom: 60px;
    .cont {
      width: 1312px;
      display: flex;
      justify-content: space-between;
      margin: 62px auto 0;
      p {
        color: #595961;
        font-size: 24px;
        padding-top: 14px;
      }
    }
  }
  .sale {
    height: 587px;
    padding-bottom: 60px;
    .cont {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      margin-top: 112px;
      .saleCard {
        position: relative;
        width: 285px;
        height: 264px;
        box-shadow: 0px 0px 10px 0px rgba(221, 221, 221, 0.5);
        border-radius: 6px;
        text-align: center;
        padding: 78px 12px 48px 24px;
        img {
          position: absolute;
          left: 70px;
          top: -72px;
          width: 144px;
          height: 144px;
        }
        .cardTitle {
          font-size: 24px;
          color: #4DB0FF;
          height: 50px;
          line-height: 50px;
          margin-top: 10px;
        }
        .cardSubTitle {
          font-size: 20px;
          color: #595961;
        }
        .desc {
          color: #8B8FA1;
          font-size: 14px;
          text-align: left;
          margin-top: 15px;
        }
      }
    }
  }
  .monitor {
    height: 700px;
    background: #FAFAFA;
    .imgWrap {
      width: 1204px;
      height: 468px;
      margin: 42px auto 0;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .threeBlock {
    width: 1200px;
    height: 1284px;
    margin: 0 auto;
    padding: 63px 0 40px;
    display: flex;
    flex-wrap: wrap;
    .imgWrap {
      padding: 0 119px 0 34px;
      img {
        width: 408px;
        height: 376px;
      }
    }
    .paragraph {
      width: 600px;
      height: 376px;
      .title {
        font-size: 32px;
        text-align: left;
      }
      .colorBlock {
        width: 28px;
        height: 4px;
        background: #55B3FF;
        margin-top: 30px;
      }
      .cont {
        font-size: 20px;
        color: #595961;
        padding-top: 48px;
        text-align: left;
      }
    }
  }
  .pattern {
    background: #fafafa;
    .imgWrap {
      img {
        display: block;
        width: 1031px;
        height: 609px;
        margin: 52px auto 0;
      }
    }
  }

  .industrySolutions {
    height: 475px;
    padding-top: 70px;
    background: url("~@/assets/images/chainE/chain_industry-solution-bg.png") no-repeat;
    .title {
      font-size: 36px;
      color: #fff;
    }
    .solutions {
      display: flex;
      width: 1200px;
      margin: 52px auto 0;
      .item {
        // display: inline-flex;
        width: 110px;
        margin-right: 45px;
        .imgWrap {
          width: 110px;
          height: 110px;
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
        p {
          font-size: 20px;
          color: #fff;
          text-align: center;
          margin-top: 15px;
        }
      }
    }
  }
}

</style>
